require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-luigi-snozzi.json") })
        }
      }, "path---en-interviste-luigi-snozzi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-luigi-snozzi!./.cache/json/en-interviste-luigi-snozzi.json
// module id = 589
// module chunks = 231608221292675